import { AdSDKHelper } from "./AdSDKHelper";

declare const sdk: any;

declare global {
    interface Window {
        gameMonetizeSDK: GameMonetizeAdSDK;
    }
}

export class GameMonetizeAdSDK extends AdSDKHelper {

    private _adShowing = false;

    init(): void {
        window.gameMonetizeSDK = this;
    }

    onReady(): void {
    console.log(">>> onReady()");
}

onPause() {
    if (!this._adShowing) {
        console.log("Ignoring stray pause");
        return;
    }

    this._pauseAndMuteGame();
}

onResume() {
    if (!this._adShowing) {
        console.log("Ignoring stray resume");
        return;
    }

    this._adShowing = false;

    this._resumeAndUnmuteGame();
    this._callCallback(true);
}

onError(): void {

    console.log(">>> onError()");

    if (!this._adShowing)
        return;

    this._adShowing = false;

    this._resumeAndUnmuteGame();

    this._callCallback(false);
}

    showInterstitialAd(
    callback: (success: boolean) => void,
    context: any
): void {

    if (this._adShowing) {
        console.warn("Ad is already showing.");
        return;
    }

    console.log(">>> showInterstitialAd()");

    this._setCallbackAndContext(callback, context);

    if (typeof sdk !== "undefined" && typeof sdk.showBanner === "function") {

        this._adShowing = true;

        console.log(">>> Calling sdk.showBanner()");

        sdk.showBanner();
    }
    else {

    this._adShowing = false;

    this._callCallback(false);
}
}
    loadRewardedAd(): void {
        // GameMonetize does not support preloading rewarded ads.
        this._rewardedAdReady = true;
    }

    showRewardedAd(
        callback: (success: boolean) => void,
        context: any
    ): void {

        // GameMonetize has no rewarded ad API.
        // Use the same ad request.
        this.showInterstitialAd(callback, context);
    }

    error(): void {
        this._callCallback(false);
    }
}